import Vue from 'vue';
import store from './../../store';
import productTagTransformer from './../../transformers/productTag';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const productTags = productTagTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);

  store.dispatch('fetchPaginatedProductTags', { productTags, pagination });
  resolve();
};

const failed = (error, reject) => reject(error);


export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('product_tags', options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productTag/items.js